var map = {
	"./1Ano/1-Ano-01-Por-Onde-Eu-Ando.png": 26,
	"./1Ano/1-Ano-02-Meios-De-Transporte.png": 27,
	"./1Ano/1-Ano-03-Ver-E-Enxergar.png": 28,
	"./1Ano/1-Ano-04-Atencao-Aos-Sons.png": 29,
	"./2Ano/2-Ano-01-Aqui-E-Seguro.png": 30,
	"./2Ano/2-Ano-02-Para-Onde-Eu-Vou.png": 31,
	"./2Ano/2-Ano-03-LocalizandoSe-Nos-Ambientes.png": 32,
	"./2Ano/2-Ano-04-Sem-Pressa.png": 33,
	"./3Ano/img1.png": 34,
	"./3Ano/img2.png": 35,
	"./3Ano/img3.png": 36,
	"./3Ano/img4.png": 37,
	"./4Ano/img1.png": 38,
	"./4Ano/img2.png": 39,
	"./4Ano/img3.png": 40,
	"./4Ano/img4.png": 41,
	"./5Ano/img1.png": 42,
	"./5Ano/img2.png": 43,
	"./5Ano/img3.png": 44,
	"./5Ano/img4.png": 45,
	"./6Ano/img1.png": 46,
	"./6Ano/img2.png": 47,
	"./6Ano/img3.png": 48,
	"./6Ano/img4.png": 49,
	"./6Ano/img5.png": 50,
	"./6Ano/img6.png": 51,
	"./6Ano/img7.png": 52,
	"./7Ano/img1.png": 53,
	"./7Ano/img2.png": 54,
	"./7Ano/img3.png": 55,
	"./7Ano/img4.png": 56,
	"./7Ano/img5.png": 57,
	"./7Ano/img6.png": 58,
	"./8Ano/img1.png": 59,
	"./8Ano/img2.png": 60,
	"./8Ano/img3.png": 61,
	"./8Ano/img4.png": 62,
	"./9Ano/img1.png": 63,
	"./9Ano/img2.png": 64,
	"./9Ano/img3.png": 65,
	"./9Ano/img4.png": 66,
	"./9Ano/img5.png": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;